export default __webpack_public_path__ + "static/media/ketosis@3x.8c184af4.jpg";